import React from 'react';

const SilkCSS = ({
  speed = 5,
  scale = 1,
  color = "#7B7481",
  noiseIntensity = 1.5,
  rotation = 0,
}) => {
  const style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `
      linear-gradient(45deg, ${color}22 25%, transparent 25%, transparent 75%, ${color}22 75%, ${color}22),
      linear-gradient(-45deg, ${color}22 25%, transparent 25%, transparent 75%, ${color}22 75%, ${color}22)
    `,
    backgroundSize: `${60 * scale}px ${60 * scale}px`,
    animation: `silkMove ${20 / speed}s linear infinite`,
    opacity: 0.3,
    pointerEvents: 'none',
    zIndex: 0,
  };

  return (
    <>
      <div style={style} />
      <style jsx>{`
        @keyframes silkMove {
          0% {
            background-position: 0 0, 0 0;
          }
          100% {
            background-position: ${60 * scale}px ${60 * scale}px, ${-60 * scale}px ${-60 * scale}px;
          }
        }
        
        @keyframes silkWave {
          0%, 100% {
            transform: translateY(0) rotate(${rotation}deg);
          }
          50% {
            transform: translateY(-10px) rotate(${rotation}deg);
          }
        }
      `}</style>
    </>
  );
};

export default SilkCSS; 